import React from 'react';
import Footer from '../../../components/Footer';

import { Wrapper } from './styles';

const AuthLayout = ({ children }) => {
  return (
    <Wrapper>
      {children}
      <Footer />
    </Wrapper>
  );
}

export default AuthLayout;